module.exports = __webpack_public_path__ + "img/gx.e351ac96.png";